import React, { useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { motion, useInView } from "framer-motion";
import {
  DiJavascript1,
  DiNodejs,
  DiJava,
  DiPython,
} from "react-icons/di";
import {
  SiMaterialui,
  SiRedux,
  SiMongodb,
  SiHtml5,
  SiSpring,
  SiThymeleaf,
  SiApachekafka,
  SiRabbitmq,
  SiGo,
  SiCss3,
  SiBootstrap,
  SiJquery,
  SiReact,
} from "react-icons/si";

const techItems = [
  { icon: <DiJava />, name: "Java" },
  { icon: <DiJavascript1 />, name: "JavaScript" },
  { icon: <DiNodejs />, name: "Node.js" },
  { icon: <SiReact />, name: "React" },
  { icon: <SiRedux />, name: "Redux" },
  { icon: <SiMongodb />, name: "MongoDB" },
  { icon: <DiPython />, name: "Python" },
  { icon: <SiGo />, name: "Go" },
  { icon: <SiSpring />, name: "Spring" },
  { icon: <SiMaterialui />, name: "Material UI" },
  { icon: <SiThymeleaf />, name: "Thymeleaf" },
  { icon: <SiApachekafka />, name: "Kafka" },
  { icon: <SiRabbitmq />, name: "RabbitMQ" },
  { icon: <SiHtml5 />, name: "HTML5" },
  { icon: <SiBootstrap />, name: "Bootstrap" },
  { icon: <SiCss3 />, name: "CSS3" },
  { icon: <SiJquery />, name: "jQuery" },
];

const cardVariants = {
  hidden: { opacity: 0, y: 30, scale: 0.9 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      delay: i * 0.06,
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  }),
};

const Techstack = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  return (
    <Row
      ref={ref}
      style={{ justifyContent: "center", paddingBottom: "50px", paddingTop: "30px" }}
    >
      {techItems.map((item, index) => (
        <Col xs={4} md={2} key={index} style={{ padding: "8px" }}>
          <motion.div
            className="tech-icons"
            custom={index}
            variants={cardVariants}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            whileHover={{
              y: -6,
              scale: 1.05,
              transition: { type: "spring", stiffness: 400, damping: 15 },
            }}
          >
            {item.icon}
            <span className="tech-icon-label">{item.name}</span>
          </motion.div>
        </Col>
      ))}
    </Row>
  );
};

export default Techstack;
